import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import type { BranchId } from '@/shared/config/funnel/constants';
import type { CardTypeOption } from '../../../model/exploreOtherCardTypes';
import { OptionCardContent } from '../../Form/SingleSelectInput/OptionCard';
import { optionCardClass, optionCardSelectedStyles } from '../../Form/SingleSelectInput/styles';
type Props = {
  options: CardTypeOption[];
  currentBranchId: BranchId;
  onSelect: (branchId: BranchId) => void;
};
export function BranchOptions(t0) {
  const $ = _c(10);
  const {
    options,
    currentBranchId,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      display: "flex",
      flexDirection: "column",
      gap: "2",
      m: "[0]",
      p: "[0]",
      listStyle: "none"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentBranchId || $[2] !== onSelect || $[3] !== options) {
    let t3;
    if ($[5] !== currentBranchId || $[6] !== onSelect) {
      t3 = option => {
        const isCurrent = option.branchId === currentBranchId;
        return <li key={option.branchId}><button type="button" aria-current={isCurrent} onClick={() => onSelect(option.branchId)} className={cx(optionCardClass, isCurrent && optionCardSelectedStyles)}><OptionCardContent iconHTML={option.icon} label={option.label} /></button></li>;
      };
      $[5] = currentBranchId;
      $[6] = onSelect;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = options.map(t3);
    $[1] = currentBranchId;
    $[2] = onSelect;
    $[3] = options;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}